<template>
  <modal id="editDistributorClient"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose
         @close="close"
  >
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('distributor_clients.edit.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-2">
        <small>{{ $t('distributor_clients.edit.helpText') }}</small>
      </div>

      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>

      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('generic.id') }}</label>
          <div class="col-md-9">
            <base-input
              disabled
              :value="formDetails.id">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('distributor_clients.details.name') }}</label>
          <div class="col-md-9">
            <base-input
              v-model="formDetails.name">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('distributor_clients.details.system_account_id') }}</label>
          <div class="col-md-9">
            <el-select
              class="select-primary mb-3 pagination-select w-100"
              v-model="formDetails.system_account_id"
            >
              <el-option
                class="select-primary"
                :key="null"
                :label="$t('distributor_clients.form.systemAccountUnassigned')"
                :value="null"
              />
              <el-option
                class="select-primary"
                v-for="item in system_accounts"
                :key="item.id"
                :label="selectItem(item)"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('distributor_clients.edit.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'edit-distributor-client-dialog',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    distributor_id: {
      type: String,
      required: true
    },
    formDetails: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    system_accounts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      alert: false,
      modelValidations: {
        required: {
          required: true
        }
      }
    }
  },
  computed: {
    ...mapState({
      updating: state => state.distributor_clients.updating,
      error: state => state.distributor_clients.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    showModal() {
      return this.show == true
    }
  },
  methods: {
    ...mapActions(['UpdateDistributorClient']),
    close: function () {
      this.alert=false
      this.$emit('close');
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    selectItem(details) {
      return details.username + ' (' + details.email + ')'
    },
    update: function () {
      this.UpdateDistributorClient({
        distributor_id: this.distributor_id,
        distributor_client_id: this.formDetails.id,
        payload: this.formDetails
      }).then(() => {
        if (this.error != null) {
          this.alert = true
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('distributor_clients.edit.updatedNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.close()
        }
      });
    }
  }
}
</script>
